import { createSlice } from "@reduxjs/toolkit";
import { defaultAddReducer, defaultSetReducer, defaultUpdateReducer, defaultRemoveReducer } from "./defaultReducer";

const initialState = {
  list: [],
};

const slice = createSlice({
  name: "actions",
  initialState,
  reducers: {
    // Give case reducers meaningful past-tense "event"-style names
    setActionsReducer: defaultSetReducer,
    updateActionReducer: defaultUpdateReducer,
    addActionReducer: defaultAddReducer,
    removeActionReducer: defaultRemoveReducer,
  },
});

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const { setActionsReducer, updateActionReducer, addActionReducer, removeActionReducer } = slice.actions;

// Export the slice reducer as the default export
export default slice.reducer;
